<template>
  <div class="page-container">
    <el-card shadow="never">
      <div class="toolbar">
        <span class="section-title">轮播图管理</span>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">
          新增轮播图
        </el-button>
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%; margin-top: 16px;"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="图片" width="220" align="center">
          <template slot-scope="scope">
            <el-image
              :src="scope.row.imageUrl"
              fit="cover"
              style="width: 200px; height: 80px; border-radius: 4px;"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="140" show-overflow-tooltip />
        <el-table-column prop="linkUrl" label="跳转链接" min-width="200" show-overflow-tooltip />
        <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.status === 1"
              active-color="#67c23a"
              inactive-color="#dcdfe6"
              @change="handleToggleStatus(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="170" />
        <el-table-column label="操作" width="160" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #ff4d4f;"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑轮播图' : '新增轮播图'"
      :visible.sync="dialogVisible"
      width="520px"
      :close-on-click-modal="false"
      @closed="handleDialogClosed"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入轮播图标题" />
        </el-form-item>
        <el-form-item label="跳转链接" prop="linkUrl">
          <el-input v-model="form.linkUrl" placeholder="请输入跳转链接" :disabled="true" />
          <el-button type="text" size="small" @click="showGoodsPicker = true" style="margin-top: 8px;">选择商品</el-button>
        </el-form-item>
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="轮播图片" prop="imageUrl">
          <el-upload
            action="/api/admin/upload"
            list-type="picture-card"
            :file-list="imageList"
            :on-preview="handlePicturePreview"
            :on-remove="handlePictureRemove"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip" style="color: #999; margin-top: 8px;">
              建议尺寸 750×340（约2.2:1），仅支持上传1张图片
            </div>
          </el-upload>
          <el-dialog :visible.sync="previewVisible" append-to-body>
            <img :src="previewUrl" style="width: 100%;" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>

      <div slot="footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="submitting" @click="handleSubmit">
            确 定
          </el-button>
        </div>
      </el-dialog>

      <!-- 商品选择弹窗 - 移到主弹窗外部 -->
      <el-dialog
        title="选择商品"
        :visible.sync="showGoodsPicker"
        width="600px"
        :close-on-click-modal="false"
        append-to-body
      >
        <el-input
          v-model="goodsKeyword"
          placeholder="搜索商品"
          style="margin-bottom: 16px;"
          @input="loadGoodsList"
        />
        <el-table
          :data="goodsList"
          v-loading="goodsLoading"
          border
          style="width: 100%;"
          @row-click="selectGoods"
        >
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column label="商品图片" width="120" align="center">
            <template slot-scope="scope">
              <el-image
                :src="getGoodsFirstImage(scope.row)"
                fit="cover"
                style="width: 80px; height: 80px; border-radius: 4px;"
              />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="商品名称" show-overflow-tooltip />
          <el-table-column prop="dailyRent" label="日租金" width="100" align="center">
            <template slot-scope="scope">¥{{ scope.row.dailyRent }}/天</template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="showGoodsPicker = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getBannerList, createBanner, updateBanner, deleteBanner, updateBannerStatus } from '@/api/banner'
import { getGoodsList } from '@/api/goods'

export default {
  name: 'BannerList',
  data() {
    return {
      tableData: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      editingId: null,
      submitting: false,
      previewVisible: false,
      previewUrl: '',
      imageList: [],
      form: {
        title: '',
        imageUrl: '',
        linkUrl: '',
        sortOrder: 0,
        status: 1
      },
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        imageUrl: [{ required: true, message: '请上传轮播图片', trigger: 'change' }]
      },
      // 商品选择相关
      showGoodsPicker: false,
      goodsList: [],
      goodsLoading: false,
      goodsKeyword: ''
    }
  },
  created() {
    this.loadData()
  },
  watch: {
    showGoodsPicker(val) {
      if (val) {
        this.goodsKeyword = ''
        this.loadGoodsList()
      }
    }
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await getBannerList()
        this.tableData = res.data || []
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    handleCreate() {
      this.isEdit = false
      this.editingId = null
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.editingId = row.id
      this.form = {
        title: row.title || '',
        imageUrl: row.imageUrl || '',
        linkUrl: row.linkUrl || '',
        sortOrder: row.sortOrder || 0,
        status: row.status || 1
      }
      this.buildImageList(row.imageUrl)
      this.dialogVisible = true
    },
    handleDialogClosed() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        title: '',
        imageUrl: '',
        linkUrl: '',
        sortOrder: 0,
        status: 1
      }
      this.imageList = []
    },
    buildImageList(imageUrl) {
      this.imageList = []
      if (imageUrl) {
        this.imageList.push({ url: imageUrl, uid: -1, status: 'success' })
      }
    },
    handlePicturePreview(file) {
      this.previewUrl = file.url
      this.previewVisible = true
    },
    handlePictureRemove(file, fileList) {
      this.imageList = fileList
      if (fileList.length === 0) {
        this.form.imageUrl = ''
      }
    },
    handleUploadSuccess(response, file, fileList) {
      this.imageList = fileList
      this.form.imageUrl = response.data
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该轮播图吗？', '提示', { type: 'warning' })
        await deleteBanner(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') console.error(e)
      }
    },
    async handleToggleStatus(row) {
      const newStatus = row.status === 1 ? 0 : 1
      try {
        await updateBannerStatus(row.id, newStatus)
        this.$message.success(newStatus === 1 ? '已启用' : '已禁用')
        this.loadData()
      } catch (e) {
        this.$message.error(e.message || '操作失败')
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEdit) {
            await updateBanner(this.editingId, this.form)
            this.$message.success('更新成功')
          } else {
            await createBanner(this.form)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          console.error(e)
        } finally {
          this.submitting = false
        }
      })
    },
    // 商品选择相关
    async loadGoodsList() {
      this.goodsLoading = true
      try {
        const params = { page: 1, size: 50, status: -1 }
        if (this.goodsKeyword) params.keyword = this.goodsKeyword
        const res = await getGoodsList(params)
        this.goodsList = (res.data && res.data.records) || []
      } catch (e) {
        console.error(e)
        this.goodsList = []
      } finally {
        this.goodsLoading = false
      }
    },
    selectGoods(row) {
      this.form.linkUrl = `/pages/goods/detail?id=${row.id}`
      this.showGoodsPicker = false
      this.$message.success('已选择商品')
    },
    getGoodsFirstImage(row) {
      if (!row) return ''
      let images = row.images || row.coverImage || row.imageUrl
      if (!images) return ''
      try {
        const arr = JSON.parse(images)
        return Array.isArray(arr) && arr.length > 0 ? arr[0] : ''
      } catch {
        if (images.includes(',')) return images.split(',')[0] || ''
        return images
      }
    }
  }
}
</script>

<style scoped>
.page-container {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f1f1f;
}

.banner-upload {
  display: inline-block;
}

.banner-upload .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  width: 240px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.3s;
}

.banner-upload .el-upload:hover {
  border-color: #1677FF;
}

.banner-upload-icon {
  font-size: 28px;
  color: #8c8c8c;
}
</style>